import './style.scss';

import { type FC, useEffect, useState } from 'react';

import { readSnapshot, subscribeCancellationChanged } from '../../../lib/cancellation-store';
import { clockTime } from './shared';

/**
 * Upload Result on a unit INEC cancelled: warn, never block — cancellations get reversed, and
 * an agent holding a real result sheet must still be able to send it. Reads only what is
 * already on the device (the upload panel is always mounted, so it must not poll).
 */
export const CancelledUnitNotice: FC<{ electionId?: number; pollingUnitCode?: string }> = ({ electionId, pollingUnitCode }) => {
	const [snapshot, setSnapshot] = useState(() =>
		electionId && pollingUnitCode ? readSnapshot(electionId, pollingUnitCode) : null
	);

	useEffect(() => {
		if (!electionId || !pollingUnitCode) {
			setSnapshot(null);
			return;
		}
		const read = () => setSnapshot(readSnapshot(electionId, pollingUnitCode));
		read();
		return subscribeCancellationChanged(electionId, pollingUnitCode, read);
	}, [electionId, pollingUnitCode]);

	if (!snapshot?.active) return null;
	const at = clockTime(snapshot.cancelledAt);

	return (
		<div
			className='pc-upload-notice'
			role='note'
		>
			<strong>INEC cancelled this unit{at ? ` at ${at}` : ''}.</strong> Upload a result only if INEC reversed it.
		</div>
	);
};

export default CancelledUnitNotice;
